"use client";

import { Tab } from "@headlessui/react";
import { classNames } from "../../utils/classNames";

type GearTabsProps = {
  selectedTab: string;
  onSelect: (tab: string) => void;
};

const GearTabs: React.FC<GearTabsProps> = ({ selectedTab, onSelect }) => {
  const tabs = [
    { name: "Brands", value: "brands" },
    { name: "Models", value: "models" },
    { name: "Versions", value: "versions" },
  ];

  const selectedIndex = tabs.findIndex((tab) => tab.value === selectedTab);

  return (
    <div className="w-full mb-8">
      <Tab.Group
        selectedIndex={selectedIndex}
        onChange={(index) => onSelect(tabs[index].value)}
      >
        <Tab.List className="flex space-x-1 rounded-xl bg-gray-100 p-1">
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm font-medium leading-5",
                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                  selected
                    ? "bg-white shadow text-blue-700"
                    : "text-gray-700 hover:bg-white/[0.12] hover:text-blue-600"
                )
              }
            >
              {tab.name}
            </Tab>
          ))}
        </Tab.List>
      </Tab.Group>
    </div>
  );
};

export default GearTabs;
